import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import {
  createPcmpRequestCategory,
  pcmpRequestCategoryQueryKeys,
  updatePcmpRequestCategory,
} from '../api/pcmpRequestCategories.api';
import type {
  PcmpRequestCategoryCreatePayload,
  PcmpRequestCategoryUpdatePayload,
} from '../types/pcmpRequestCategory.types';

/** Create (no id) or update one request category. Errors stay inline in the dialog. */
export function useSavePcmpRequestCategory(categoryId: number | null, onSuccess: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpRequestCategoryCreatePayload) => {
      if (categoryId === null) return createPcmpRequestCategory(payload);
      // The code is fixed once the category exists.
      const update: PcmpRequestCategoryUpdatePayload = {
        name: payload.name,
        appliesTo: payload.appliesTo,
        actionPlanKey: payload.actionPlanKey,
        isActive: payload.isActive,
      };
      return updatePcmpRequestCategory(categoryId, update);
    },
    onSuccess: (category) => {
      // The requester's category list reads the same rows.
      void queryClient.invalidateQueries({ queryKey: pcmpRequestCategoryQueryKeys.all() });
      void queryClient.invalidateQueries({ queryKey: ['pcmp-requests'] });
      toast.success(
        categoryId === null
          ? `Category "${category.name}" added`
          : `Category "${category.name}" updated`,
      );
      onSuccess();
    },
  });
}
